/* tslint:disable */
/* eslint-disable */
/**
 * OU-AAO API
 * This is a definition of Osaka University AAD Application API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: t.shinohara@mmj.ne.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface EducationCertificateCategoryType
 */
export interface EducationCertificateCategoryType {
  /**
   *
   * @type {number}
   * @memberof EducationCertificateCategoryType
   */
  id: number
  /**
   *
   * @type {boolean}
   * @memberof EducationCertificateCategoryType
   */
  required: boolean
}

export function EducationCertificateCategoryTypeFromJSON(
  json: any
): EducationCertificateCategoryType {
  return EducationCertificateCategoryTypeFromJSONTyped(json, false)
}

export function EducationCertificateCategoryTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EducationCertificateCategoryType {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    required: json['required'],
  }
}

export function EducationCertificateCategoryTypeToJSON(
  value?: EducationCertificateCategoryType | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    required: value.required,
  }
}
